import { render, staticRenderFns } from "./FireQuoteUpdateStatus.vue?vue&type=template&id=6242fbf0&"
import script from "./FireQuoteUpdateStatus.vue?vue&type=script&lang=js&"
export * from "./FireQuoteUpdateStatus.vue?vue&type=script&lang=js&"
import style0 from "./FireQuoteUpdateStatus.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "FireQuoteUpdateStatus.vue"
export default component.exports